import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@thinglogix/ngx-foundry-core';
import { environment } from 'src/environments/environment';
import { FndyUserService } from '@thinglogix/ngx-foundry-core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs';
@Component({
    selector: 'li-active-user',
    templateUrl: './active-user.component.html',
    styleUrls: ['./active-user.component.sass'],
})
export class ActiveUserComponent implements OnInit {
    activatingUser = false;

    errorMessage = '';

    user_id = '';

    account_id = '';

    activateResendEmail = false;

    message = '';

    error = false;

    linkExpired = false;

    resendEmailForm: FormGroup = this.fb.group({
        email: ['', [Validators.required]],
    });

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private authService: AuthService,
        private userService: FndyUserService
    ) {}

    ngOnInit(): void {
        this.route.queryParams.subscribe((params) => {
            this.user_id = params['user_id'];
            this.account_id = params['account_id'];
        });
        this.activateUser();
    }

    /**
     * Calls the activate user API and controls the loader
     */
    private activateUser(): void {
        this.error = false;
        this.linkExpired = false;
        this.activatingUser = true;
        this.authService
            .activateUser(this.account_id, this.user_id)
            .pipe(
                finalize(() => {
                    this.activatingUser = false;
                })
            )
            .subscribe({
                next: () => {
                    this.message = 'User is now active';
                },
                error: (err) => {
                    if (err.error) {
                        this.message = err.error.error;
                        if (this.message === 'Link is expired') {
                            this.linkExpired = true;
                        } else {
                            this.error = true;
                        }
                    }
                },
            });
    }

    /**
     * Calls the resend the activation email  API using the form value
     *
     * @returns Promise<void> Promise with void value after the API has been called
     */

    async resendEmail(): Promise<void> {
        const email: string = this.resendEmailForm.value.email.trim();

        this.userService
            .resendActivationEmail(email, environment.liquidInsightAccountId)
            .subscribe();
    }
}
